/*	Desktop View Header Search Code	*/
let _originalSize = NaN;

$('.desktopSearchHeader .dd-menu li').click(function () {
		let schoolTypeName = $(this).text().trim();
		let schoolType = $(this).attr('data-school-type');
		if (schoolTypeName.length > 15) schoolTypeName = schoolTypeName.slice(0, 12);		
		$('.desktopSearchHeader .dd-button').text(schoolTypeName);
		$('#DeskSchoolType').val(schoolType);
});

/*	Search Map Suggestion with autocomplete Desktop	*/

const search_input_DeskTop = document.getElementById('DeskHeaderSearchInput');
const search_option_DeskTop = {componentRestrictions: {country: 'in'}, fields: ["place_id"]};
const search_autocomplete_DeskTop = new CustomAutoCompleteMaps(search_input_DeskTop);
let searched_place_DeskTop = '';

// console.log(search_input_DeskTop, 'search_input_DeskTop');
if(!!search_input_DeskTop){
		CustomAutoCompleteMaps.addListener(search_autocomplete_DeskTop, 'place_changed', () => {
				searched_place_DeskTop = search_autocomplete_DeskTop.getPlace();
		});
}

$('#DeskHeaderSearchButton').click(function (e) {
		e.preventDefault();
		/*	school type slider field	*/
		let school_type = $('#DeskSchoolType').val();
		let school_type_text = getSchoolTypeSearchText(school_type);
		localStorage.setItem('searched_school_type', school_type);

		if (school_type === 6) {
				window.location.href = `${HOST}/search/${school_type_text}/?`;
				return false;
		}

		if (school_type_text === undefined) {
				launchErrorToast('Please Select School Type');
				return false;
		}

		let place_name = search_input_DeskTop.value;
		let city2 = '';
		if (searched_place_DeskTop !== "") city2 = searched_place_DeskTop.formatted_address.split(',')[0];		

		if ((place_name === '' && city2 === undefined) || searched_place_DeskTop === '') {
				launchErrorToast('Please type location');
				return false;
		}

		/*	analytics header search	*/
		HeaderSearchAnalytics(school_type_text);

		let place_level = searched_place_DeskTop.address_components[0].types[0];
		let place_lat = searched_place_DeskTop.geometry.location.lat();
		let place_lng = searched_place_DeskTop.geometry.location.lng();

		let formatted_address = searched_place_DeskTop.formatted_address;
		formatted_address = slugify(formatted_address);
		/*	when state search apply to add parameter state in query Params	*/
		if (place_level === 'administrative_area_level_1' && (school_type === 3)) formatted_address += `/?state=${formatted_address}`;		

		/*	Insert Search History Code	*/

		let searchPageName = (typeof (pageType) != "undefined") ? pageType : window.location.href;
		let SearchText = `${school_type_text} in ${formatted_address}`;
		let cityText = '';
		for (let i = 0; i < searched_place_DeskTop.address_components.length; i++) {
				const addr = searched_place_DeskTop.address_components[i];
				if (addr.types[0] === ['locality']) cityText = addr.long_name;	/*	City	*/
		}

		let InsertSearchParameter = {
				'page': searchPageName,
				'city': cityText,
				'filter': '',
				'filter_text': SearchText,
				'type_id': school_type,
				'location_short': city2,
				'location_long': formatted_address,
				'lat': place_lat,
				'long': place_lng,
		};

		InsertSearchApi(InsertSearchParameter);

		/* INSERT SEARCH HISTORY CODE END */

		$.ajax({
				url: `${HOST}/home/encode_decode.php`,
				data: {latitude: place_lat, longitude: place_lng},
				async: true,
				error: function () {
						alert("Something went wrong!");
				},
				success: function (response) {
						response = JSON.parse(response);
						window.location.href = `${HOST}/search/${school_type_text}/${formatted_address.toLowerCase()}-${response.data.latlng}/?place_level=${place_level}&city2=${city2.toLowerCase().split(" ").join("-").split(",").join("-").split("--").join("-")}`;
				},
				type: 'GET'
		});
});

// Search history if present from local storage
setSearchTypeByHistory();

/*	Mobile Search Autocomplete Code	*/

$('.mobileSearchForm .dd-menu li').click(function () {
		let schoolTypeName = $(this).text().trim();
		let schoolType = $(this).attr('data-school-type');
		if (schoolTypeName.length > 12) schoolTypeName = schoolTypeName.slice(0, 12);
		$('.mobileSearchForm .dd-button').text(schoolTypeName);
		$('#MobSchoolType').val(schoolType);
});


/*	Search Map Suggestion with autocomplete Mobile	*/

const search_input_Mobile = document.getElementById('MobHeaderSearchInput');
const search_option_Mobile = {componentRestrictions: {country: 'in'}, fields: ["place_id"]};
const search_autocomplete_Mobile = new CustomAutoCompleteMaps(search_input_Mobile);
let searched_place_Mobile = '';

if(!!searched_place_Mobile){
		CustomAutoCompleteMaps.addListener(search_autocomplete_Mobile, 'place_changed', () => {
				searched_place_Mobile = search_autocomplete_Mobile.getPlace();
		});
}

$('#MobHeaderSearchButton').click(function (e) {
		e.preventDefault();
		/*	school type slider field	*/
		let school_type = $('#MobSchoolType').val();
		let school_type_text = getSchoolTypeSearchText(school_type);
		localStorage.setItem('searched_school_type', school_type);

		if (school_type_text === undefined) {
				launchErrorToast('Please Select School Type');
				return false;
		}

		let place_name = search_input_Mobile.value;
		let city2 = '';
		if (searched_place_Mobile !== "") city2 = searched_place_Mobile.formatted_address.split(',')[0];

		if ((place_name === '' && city2 === undefined) || searched_place_Mobile === '') {
				launchErrorToast('Please type location');
				return false;
		}

		/*	analytics header search	*/
		HeaderSearchAnalytics(school_type_text);

		let place_level = searched_place_Mobile.address_components[0].types[0];
		let place_lat = searched_place_Mobile.geometry.location.lat();
		let place_lng = searched_place_Mobile.geometry.location.lng();

		let formatted_address = searched_place_Mobile.formatted_address;
		formatted_address = slugify(formatted_address);
		/*	when state search apply to add parameter state in query Params	*/
		if (place_level === 'administrative_area_level_1' && (school_type === 3)) formatted_address += `/?state=${formatted_address}`;

		/*	Insert Search History Code	*/

		let searchPageName = (typeof (pageType) != "undefined") ? pageType : window.location.href;
		let SearchFilter = {'location': city2};
		let SearchText = `${school_type_text} in ${formatted_address}`;
		let cityText = '';
		for (let i = 0; i < searched_place_Mobile.address_components.length; i++) {
				const addr = searched_place_Mobile.address_components[i];
				if (addr.types[0] === ['locality']) cityText = addr.long_name;	/*	City	*/
		}

		let InsertSearchParameter = {
				'page': searchPageName,
				'city': cityText,
				'filter': JSON.stringify(SearchFilter),
				'filter_text': SearchText,
				'type_id': school_type,
				'location_short': city2,
				'location_long': formatted_address,
				'lat': place_lat,
				'long': place_lng,
		};

		InsertSearchApi(InsertSearchParameter);

		/* INSERT SEARCH HISTORY CODE END */

		$.ajax({
				url: `${HOST}/home/encode_decode.php`,
				data: {latitude: place_lat, longitude: place_lng},
				async: true,
				error: function () {
						alert("Something went wrong!");
				},
				success: function (response) {
						response = JSON.parse(response);
						window.location.href = `${HOST}/search/${school_type_text}/${formatted_address.toLowerCase()}-${response.data.latlng}/?place_level=${place_level}&city2=${city2.toLowerCase().split(" ").join("-").split(",").join("-").split("--").join("-")}`;
				},
				type: 'GET'
		});
});


function launchErrorToast(text) {
		$('#headerSearchToast').html('<i class="fa fa-exclamation errorIcon"></i>' + text);
		const x = document.getElementById("headerSearchToast");
		x.className = "show";
		setTimeout(function () {
				x.className = x.className.replace("show", "");
		}, 3000);
}

function slugify(string) {
		const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;';
		const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------';
		const p = new RegExp(a.split('').join('|'), 'g');

		return string.toString().toLowerCase()
				.replace(/\s+/g, '-') /*	Replace spaces with -	*/
				.replace(p, c => b.charAt(a.indexOf(c))) /*	Replace special characters	*/
				.replace(/&/g, '-and-') /*	Replace & with 'and'	*/
				.replace(/[^\w\-]+/g, '') /*	Remove all non-word characters	*/
				.replace(/\-\-+/g, '-') /*	Replace multiple - with single -	*/
				.replace(/^-+/, '') /*	Trim - from start of text	*/
				.replace(/-+$/, '') /*	Trim - from end of text	*/
}

function getSchoolTypeSearchText($schoolType) {
		$schoolType = parseInt($schoolType);
		if ($schoolType === 1) return 'day-school';
		else if ($schoolType === 2) return 'pre-school';
		else if ($schoolType === 3) return 'boarding-school';
		else if ($schoolType === 5) return 'pu-junior-colleges';
		else if ($schoolType === 4) return 'day-care';
}

// check element is in viewport
// How to use $('#Slider').isInViewport() == true
$.fn.isInViewport = function () {
		if (typeof pageType !== 'undefined' && pageType !== 'authors_page') {
				const elementTop = $(this).offset().top;
				const elementBottom = elementTop + $(this).outerHeight();
				const viewportTop = $(window).scrollTop();
				const viewportBottom = viewportTop + $(window).height();
				return elementBottom > viewportTop && elementTop < viewportBottom;
		}
};

/*	check s mobile and Ipad Device	*/
window.mobileAndTabletCheck = function () {
		let check = false;
		(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
		})(navigator.userAgent || navigator.vendor || window.opera);
		return check;
};

/*	check Mobile Device Only	*/
window.mobileCheck = function () {
		let check = false;
		(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
		})(navigator.userAgent || navigator.vendor || window.opera);
		return check;
};

document.body.addEventListener("click", function (evt) {
		checkModalOpen();
		let target = $(evt.target);
		let deskSchoolTypeElm = $('#DeskSchoolType');
		let mobSchoolTypeElm = $('#MobSchoolType');
		let checkedProp = deskSchoolTypeElm.prop('checked');
		let mobCheckProp = mobSchoolTypeElm.prop('checked');

		if (target && target[0] && target[0].className === 'dd-button' && checkedProp) {
				deskSchoolTypeElm.prop('checked', false);
				evt.preventDefault();
				return false;
		} else if (target && target[0] && target[0].className === 'dd-button' && mobCheckProp) {
				mobSchoolTypeElm.prop('checked', false);
				evt.preventDefault();
				return false;
		} else if (target && target[0] && target[0].id && (target[0].id === 'DeskSchoolType')) return false;
		else if (target && target[0] && target[0].id && (target[0].id === 'MobSchoolType')) return false;
		else if ($(target[0]).parent().parent().attr('class') === 'dropdown') return false;

		if (checkedProp) {
				deskSchoolTypeElm.prop('checked', false);
				return false;
		}
		if (mobCheckProp) {
				mobSchoolTypeElm.prop('checked', false);
				return false;
		}
});

function headerSchoolTypeSelect(schoolType) {
		setTimeout(function () {
				$(".desktopSearchHeader ul").find("[data-school-type='" + schoolType + "']").trigger('click');
				$(".mobileSearchForm ul").find("[data-school-type='" + schoolType + "']").trigger('click');
				$('#DeskSchoolType').prop('checked', false);
				$('#MobSchoolType').prop('checked', false);
		}, 200)

}

function setSearchTypeByHistory() {
		let searchedSchool = localStorage.getItem('searched_school_type');
		if (searchedSchool) headerSchoolTypeSelect(searchedSchool);
}

function checkModalOpen() {
		/*	if modal open is in window then hide all icons	*/
		setTimeout(function () {
				if ($('.modal.in').length > 0 || $('.modal.show').length > 0) hideAllChatIcons();
				else showAllChatIcons();

		}, 500);
}

function hideAllChatIcons() {
		$("#mobFab").hide();
		if (mobileCheck()) {
				$('.button_1O').attr('style', 'display: none !important');
				$('#_hj-f5b2a1eb-9b07_feedback ._hj-f5b2a1eb-9b07_hotjar_buddy').attr('style', 'display: none !important');
		}
}

function showAllChatIcons() {
		if ($(window).width() + $(window).height() !== _originalSize) {
				hideAllChatIcons();
		} else {
				if (mobileCheck()) {
						$("#mobFab").show();
						$('.button_1O').attr('style', 'display: block !important');
						$('#_hj-f5b2a1eb-9b07_feedback ._hj-f5b2a1eb-9b07_hotjar_buddy').attr('style', 'display: block !important');
				}
		}
}

function checkSmartSearchLogin() {
		if (user) {
				getUserAssistantDetails();
				$('#AssistantModal').modal('show');
		} else $('#AssistantModal').modal('show');

}


$(document).ready(function () {
		_originalSize = $(window).width() + $(window).height();
		$(window).resize(function () {
				if ($(window).width() + $(window).height() !== _originalSize) hideAllChatIcons();
				else showAllChatIcons();
		});
});

function placeChangedDebugApiCallAnalytics() {
	gtag('event', {
		event_category: 'debug_api_call',
		event_action: 'place_changed',
		event_label: 'place_changed_website_side'
	});
}

function InsertSearchApi(SearchParameter) {
		$.ajax({
				type: 'POST',
				url: `${HOST}/searches/index.php?action=insert`,
				data: SearchParameter,
				success: function (data) {
						if (DEBUG) console.log('Recent Searches Successfully added');
				}
		});
}
